/*
 * @Author: zhaoyu zhaoyu@belink.com
 * @Date: 2022-08-24 14:12:06
 * @LastEditors: caoshuai 63615488@qq.com
 * @LastEditTime: 2022-10-24 16:54:32
 * @FilePath: \pscd-portal-new-workbench\packages\clients\src\store.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import lodash from 'lodash';
import { configure } from 'mobx';
import * as Controller from './controller';
import Env from './env';
import { AjaxBasics, Log } from './libraries';
AjaxBasics.defaultAjaxConfig.statusPath = ['status', 'code', 'errorCode'];
AjaxBasics.defaultAjaxConfig.responsePath = ['data'];
AjaxBasics.defaultAjaxConfig.messagePath = ['msg', 'message', 'errorMsg'];
configure({ enforceActions: 'observed' });
export function createStore() {
    // 从 基座获取的全局状态
    const GlobalData = lodash.result(window, 'microApp.getGlobalData');
    // 基座 的 基础状态函数
    const inheritStore = lodash.get(GlobalData, 'inheritStore', initStore);
    const Store = inheritStore();
    AjaxBasics.merge = async (AjaxConfig) => {
        function setHeaders() {
            // 配置 token
            if (Store.System.AccessToken) {
                lodash.merge(AjaxConfig, {
                    headers: { ['bp-token']: Store.System.AccessToken },
                });
            }
            // 配置 token
            if (Store.Mudu.liveSourceToken) {
                lodash.merge(AjaxConfig, {
                    headers: { ['x-source-token']: Store.Mudu.liveSourceToken },
                });
            }
            // 分享码（直播用不到）
            // if (Store.Share.shareCode) {
            //   lodash.merge(AjaxConfig, {
            //     headers: { 'x-bp-promo-code': Store.Share.getHeaderValue() },
            //   });
            // }
            // BU
            if (Store.Share.businessType) {
                lodash.merge(AjaxConfig, {
                    headers: { 'x-business-unit': Store.Share.businessType },
                });
            }
        }
        //如果是管理端 设置x-usf-token
        if (Env.isManage) {
            let ajaxUrl = AjaxConfig.url;
            if (lodash.includes(AjaxConfig.url, '/api/gateway')) {
                ajaxUrl = AjaxConfig.url.replace('/api/gateway/', '/api/ingateway/');
            }
            lodash.merge(AjaxConfig, {
                url: ajaxUrl,
                headers: {
                    'x-usf-token': Store.System.AccessToken,
                },
            });
            return AjaxConfig;
        }
        else {
            setHeaders();
            // 默认 所有请求都需要等待用户完成 带有标记 和 已完成 则跳过
            if (lodash.eq(AjaxConfig.awaitAuthenticated, false) ||
                Store.System.Auth.HydrateisStopped) {
                return AjaxConfig;
            }
            Log.warning(`等待用户初始化完成 【 ${AjaxConfig.url} 】`, AjaxConfig);
            await Store.System.Auth.HydrateAsync;
            setHeaders();
            return AjaxConfig;
        }
    };
    return Store;
}
/**
 * 初始化状态
 * @returns
 */
function initStore() {
    let SystemConstructor;
    if (Env.isManage) {
        SystemConstructor = Controller.ManageController;
    }
    else {
        SystemConstructor = Controller.SystemController;
    }
    return {
        /** 系统 登陆注册 */
        System: new SystemConstructor(),
        Common: new Controller.CommonController(),
        /** 微信 */
        Wechat: new Controller.WechatController(Env.appid),
        /** 分享 */
        Share: new Controller.ShareController(),
        /** 非业务公共 */
        Currency: new Controller.CurrencyController(),
        /** 目睹直播 */
        Mudu: new Controller.MuduController(),
    };
}
